import { marked } from 'marked';
import DOMPurify from 'dompurify';

/**
 * Replace {{PLACEHOLDER:description}} markers with HTML spans
 * that TipTap's Placeholder extension can parse via its parseHTML rule.
 */
function protectPlaceholderMarkers(text: string): string {
  return text.replace(
    /\{\{PLACEHOLDER:([^}]+)\}\}/g,
    (_match, desc: string) => {
      const id = crypto.randomUUID();
      const escaped = desc.trim().replace(/"/g, '&quot;');
      return `<span data-placeholder="" data-description="${escaped}" data-placeholder-id="${id}" class="placeholder-pill">${escaped}</span>`;
    }
  );
}

/**
 * Convert markdown text (from LLM streaming output) to HTML string
 * that TipTap can parse natively via its registered extensions.
 *
 * Placeholder markers are converted to HTML spans before marked.parse()
 * so they survive markdown processing and get picked up by TipTap's
 * Placeholder extension parseHTML rule.
 */
export function markdownToHtml(text: string): string {
  if (!text || !text.trim()) {
    return '<p>&nbsp;</p>';
  }
  const withPlaceholders = protectPlaceholderMarkers(text);
  const rawHtml = marked.parse(withPlaceholders, { async: false }) as string;
  return DOMPurify.sanitize(rawHtml, {
    ADD_ATTR: ['data-placeholder', 'data-description', 'data-placeholder-id'],
    ADD_TAGS: ['mark'],
  });
}
